import React                     from 'react';
import { Observe }               from 'rewire-core';
import { WithStyle }             from 'rewire-ui';
import classNames                from 'classnames';
import { Theme }                 from '@material-ui/core/styles';
import DateNav                   from '../ui/DateNav';
import DateRangeNavModel         from './DateRangeNavModel';
import { withStyles }            from '../utility/styles';

const styles = (theme: Theme) => ({
  dateContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: '0 1 auto',
    marginRight: '20px',
    flexWrap: 'wrap',
  },
  dateNav: {
    marginBottom: '7px',
    marginRight: '20px',
  },
  endDate: {
    marginBottom: '7px',
    marginRight: '20px',
    width: '130px',
  },
  dateDuration: {
    marginBottom: '7px',
    flex: '0',
    minWidth: '120px',
  },
  dateError: {
    marginLeft: '10px',
    fontStyle: 'italic',
    color: theme.palette.error.main,
  },
});

interface IDateRangeNavProps {
  model:         DateRangeNavModel;
  className?:    string;
  classes?:      any;
  hideDate?:     boolean;
  hideDuration?: boolean;
}

type DateRangeNavProps = WithStyle<ReturnType<typeof styles>, IDateRangeNavProps>;

class DateRangeNav extends React.PureComponent<DateRangeNavProps> {
  constructor(props: DateRangeNavProps) {
    super(props);
  }

  render() {
    const {model, classes, className, hideDate, hideDuration} = this.props;

    return <Observe render={() => {
      const isCustomSelected:  boolean = model.isCustom;
      const disableNavigation: boolean = model.disableNavigation;
      const DateComponent              = model.form.field.startDate.Editor;
      const onPreviousClick            = () => model.setDateToPrevious();
      const onNextClick                = () => model.setDateToNext();

      return (
        <div className={classNames(classes.dateContainer, className)}>
          {!hideDate && <DateNav className={classes.dateNav} disableNavigation={disableNavigation} DateComponent={DateComponent} onPreviousClick={onPreviousClick} onNextClick={onNextClick} />}
          {!hideDate && isCustomSelected && model.showEndDate && <model.form.field.endDate.Editor className={classes.dateNav} />}
          {!hideDuration && <model.form.field.dateDuration.Editor className={classes.dateDuration} />}
          {!hideDate && isCustomSelected && <span className={classes.dateError}>{model.dateError}</span>}
        </div>
      );
    }} />;
  }
}

export default withStyles<IDateRangeNavProps>(styles, DateRangeNav);
